(function () {
  const _0xSec = ['contextmenu', 'preventDefault'];

  document.addEventListener(_0xSec[0], function (e) {
    e[_0xSec[1]]();
  });

  document.onkeydown = function (e) {
    if (
      e.keyCode == 123 ||
      (e.ctrlKey && e.shiftKey && e.keyCode == 73) ||
      (e.ctrlKey && e.keyCode == 85)
    ) {
      return false;
    }
  };
})();

(function () {
  function initSizeConfirm(sectionId) {
    if (!sectionId) return;

    let submitting = false;

    const selectors = {
      trigger: '.custom-add-to-cart-trigger',
      popupPrefix: 'size-confirm-popup-',
      sizeTextPrefix: 'popup-selected-size-',
      checkboxPrefix: 'size-confirm-checkbox-',
      confirmBtnPrefix: 'popup-confirm-btn-',
      formPrefix: 'custom-product-form-'
    };

    document.addEventListener('click', async function (e) {
      const target = e.target;

      if (target.closest(selectors.trigger)) {
        const clickedBtn = target.closest(selectors.trigger);
        const form = document.getElementById(selectors.formPrefix + sectionId);

        if (!form || !clickedBtn.closest('form') || clickedBtn.closest('form').id !== form.id) {
          return;
        }

        e.preventDefault();

        const selectedSize =
          document.querySelector('.variant-picker__option-values input:checked + label span')?.textContent.trim() || "";

        const sizeTextEl = document.getElementById(selectors.sizeTextPrefix + sectionId);
        const popupEl = document.getElementById(selectors.popupPrefix + sectionId);

        if (sizeTextEl) sizeTextEl.textContent = selectedSize;
        if (popupEl) popupEl.style.display = 'flex';

        return;
      }

      if (target.id === selectors.confirmBtnPrefix + sectionId) {
        if (submitting) return;

        submitting = true;
        target.innerText = "...";

        const variantInput = document.querySelector(`#${selectors.formPrefix + sectionId} input[name="id"]`);
        const id = variantInput ? variantInput.value : null;

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: id, quantity: 1 }]
            })
          });

          if (response.ok) {
            location.reload();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          window.location.href = '/cart';
        }
      }

      if (target.closest('.cancel-btn') || target.id === selectors.popupPrefix + sectionId) {
        const popupEl = document.getElementById(selectors.popupPrefix + sectionId);
        if (popupEl) popupEl.style.display = 'none';
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.id === selectors.checkboxPrefix + sectionId) {
        const confirmBtn = document.getElementById(selectors.confirmBtnPrefix + sectionId);
        if (confirmBtn) {
          confirmBtn.disabled = !e.target.checked;
        }
      }
    });
  }

  function boot() {
    if (!window.customSizeConfirmConfig || !Array.isArray(window.customSizeConfirmConfig)) return;

    window.customSizeConfirmConfig.forEach(function (item) {
      initSizeConfirm(item.sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();